<script>

    import { toast } from 'bulma-toast'
    import { userStore, notifyStore, modalStore } from '../stores'
    import { schemesStore } from '../stores'

    import SchemesService from '../$services/schemes.service.js'
    import Date from '../$components/date.svelte'

    import Form from '../$components/form.svelte'

    import InputText from '../$components/input.text.svelte'

    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'

    let data = {}
    let loading = false

    async function createScheme() {
        
        data.userId = $userStore._id
        
        loading = true
        const resp = await SchemesService.createScheme(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message})

        schemesStore.append(resp.data)
        notifyStore.set('scheme_update')
        data = {}

        toast({message: 'Esquema creado', type: 'is-success'})
    }

</script>

<Form on:submit={createScheme} { loading } >

    <InputText bind:value={data.name} label="Nombre del esquema" placeholder="Nombre del esquema" />
    
    <Date label="Fecha de expiración" bind:value={data.expired}/>

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave icon="plus" text="Crear" { loading } />
    </div>

</Form>